import { render, staticRenderFns } from "./SegundaViaCasamento.vue?vue&type=template&id=6ed548da&"
import script from "./SegundaViaCasamento.vue?vue&type=script&lang=js&"
export * from "./SegundaViaCasamento.vue?vue&type=script&lang=js&"
import style0 from "./SegundaViaCasamento.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports